// updateLiveStreamPreset.js
'use strict';
import {
  REMOVE_OPERATION_DATA,
  MERGE_LIVE_STREAM_DATA,
  MERGE_OPERATION_DATA,
} from '../ActionTypes.js';
import { PRESET_PREVIEW, PRESET_SD } from '../resource/liveStreamConstants.js';
import clearRemoveStreamTokenTimer from '../action/clearRemoveStreamTokenTimer.js';
import getOperationData from '../selector/getOperationData.js';
import getExternalData from '../selector/getExternalData.js';
import { geHasStreamToken } from '../selector/getLivestreamComputedData.js';
import trackMixpanel, { EventTypes } from '../resource/mixpanel.js';

/**
 * Update live stream preset
 * @kind action
 * @param {'sd'|'preview'} {preset} - stream preset.
 * @param {'sd'|'preview'} {pusherPreset} - puser subscribeing  preset.
 * @param {string} {streamId} - live stream id.
 * @param {string} {streamToken} - live stream token.
 * @param {object} {decodedToken} - decoded stream token.
 * @param {string} {byteplusToken} - byteplus rtc room token.
 * @param {number} {byteplusTokenNbf} - byteplus rtc room token nbf.
 * @param {number} {byteplusTokenExp} - byteplus rtc room token exp.
 * @return {Promise} Action promise.
 */
const updateLiveStreamPreset =
  ({
    preset,
    pusherPreset,
    streamId,
    streamToken,
    decodedToken,
    byteplusToken,
    byteplusTokenNbf,
    byteplusTokenExp,
    reason,
  }) =>
  async (dispatch, getState) => {
    if (preset === PRESET_PREVIEW) {
      // Tracking: log every preset-to-preview switch for debugging
      const hasToken = geHasStreamToken(getState(), streamId);
      const decodedToken = getOperationData(
        getState(),
        ['liveStream', 'paid', streamId],
        'decodedToken'
      );
      const byteplusTokenNbf = getOperationData(
        getState(),
        ['liveStream', 'paid', streamId],
        'byteplusTokenNbf'
      );
      const byteplusTokenExp = getOperationData(
        getState(),
        ['liveStream', 'paid', streamId],
        'byteplusTokenExp'
      );
      const clientTimestamp = getExternalData(
        getState(),
        ['timestamp'],
        'client'
      );
      const serverTimestamp = getExternalData(
        getState(),
        ['timestamp'],
        'server'
      );

      trackMixpanel({
        type: EventTypes.LIVESTREAM_CHANGE_PRESET,
        payload: {
          streamId,
          preset,
          reason,
          hasToken,
          clientTimestamp,
          serverTimestamp,
          tokenNbf: decodedToken?.nbf,
          tokenExp: decodedToken?.exp,
          byteplusTokenNbf,
          byteplusTokenExp,
        },
      });
      dispatch({
        type: REMOVE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream', 'paid', streamId],
        },
      });
      dispatch(clearRemoveStreamTokenTimer({ streamId }));
    }
    if (preset === PRESET_SD && streamToken) {
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream', 'paid', streamId],
          data: {
            streamToken,
            decodedToken,
            byteplusToken,
            byteplusTokenNbf,
            byteplusTokenExp,
          },
        },
      });
    }
    return dispatch({
      type: MERGE_LIVE_STREAM_DATA,
      payload: {
        selectPath: [streamId],
        data: { preset, pusherPreset },
      },
    });
  };

export default updateLiveStreamPreset;
